import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

// ===== STATIC IMPORTS FOR OFFLINE SUPPORT =====
// All components are imported statically to ensure they're bundled together
// and available offline. This is critical for PWA functionality.

import SignIn from "../pages/Auth/SignIn";
import Signup from "../pages/Auth/SignUp";
import OtpRegistration from "../pages/Auth/OtpRegistration";
import ForgotPassword from "../pages/Auth/ForgotPassword";

export default function UnathenticatedRoutes({ signedIn, user }) {
  return (
    <Routes>
      <Route
        path="/login"
        element={<SignIn signedIn={signedIn} user={user} />}
      />
      <Route
        path="/signup"
        element={<Signup signedIn={signedIn} user={user} />}
      />
      <Route
        path="/request-otp"
        element={<OtpRegistration signedIn={signedIn} user={user} />}
      />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path={"/*"} element={<Navigate replace to="/login" />} />
    </Routes>
  );
}
